import { Badge } from '../Badge/Badge'
import type { AvailabilityBadgeProps } from './AvailabilityBadge.types'

export function AvailabilityBadge({ enabled }: AvailabilityBadgeProps) {
  return enabled ? (
    <Badge color="green">Enabled</Badge>
  ) : (
    <Badge color="red">Disabled</Badge>
  )
}
